import { SharedReportsModule } from './../shared-reports/shared-reports.module';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgApexchartsModule } from 'ng-apexcharts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ReportsRoutingModule } from './reports-routing.module';

import { AllReportComponent } from './all-report/all-report.component';
import { DashReportComponent } from './dash-report/dash-report.component';
import { SpecialDealsReportComponent } from './special-deals-report/special-deals-report.component';
import { PerformanceReportComponent } from './performance-report/performance-report.component';
import { PeriodReportComponent } from './period-report/period-report.component';
import { SalesReportComponent } from './sales-report/sales-report.component';
import { ClientReportComponent } from './client-report/client-report.component';
import { DatatableModule } from 'inn-datatable';
import { CompanyReportComponent } from './company-report/company-report.component';
import { LeadsReportComponent } from './leads-report/leads-report.component';
import { TasksComponent } from './tasks/tasks.component';


const sharedComponents = [
  AllReportComponent,
];
@NgModule({
  declarations: [
    ...sharedComponents,
    DashReportComponent,
    SpecialDealsReportComponent,
    PerformanceReportComponent,
    PeriodReportComponent,
    SalesReportComponent,
    ClientReportComponent,
    CompanyReportComponent,
    LeadsReportComponent,
    TasksComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedReportsModule,
    ReportsRoutingModule,
    DatatableModule,
    NgApexchartsModule,
    BsDatepickerModule,
  ],
  exports: [...sharedComponents,]
})
export class ReportsModule { }
